import { render, staticRenderFns } from "./InfoViajeVuelta.vue?vue&type=template&id=2e8df412&scoped=true&"
import script from "./InfoViajeVuelta.vue?vue&type=script&lang=js&"
export * from "./InfoViajeVuelta.vue?vue&type=script&lang=js&"
import style0 from "./InfoViajeVuelta.vue?vue&type=style&index=0&id=2e8df412&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8df412",
  null
  
)

export default component.exports